import { Outlet } from "react-router";

import { AdminApplicationsCard } from "@components/Cards/AdminApplicationsCard/AdminApplicationsCard";

export const ApplicationsPage = () => {
  return (
    <>
      <AdminApplicationsCard />
      <Outlet />
    </>
  );
};